// extracted by mini-css-extract-plugin
export default {"itemsContainer":"RewardsCarousel_itemsContainer__k6MyL","item":"RewardsCarousel_item__clqJI","itemCurrent":"RewardsCarousel_itemCurrent__uCpSw"};